/* ASELECION – Interaktion */
(function () {
  var LS_LANG = 'asel-lang';
  var CSS =
    'html.dark .asel,html.dark body.asel{--bg:#26231F;--hero:#2B2824;--ink:#EEE9DF;--muted:#B8B1A5;--line:#3F3A33;--green:#9CCBAB;--sage:#343A2F;--dark:#1A1816}' +
    'html.dark,html.dark body.asel{background:#26231F;color:#EEE9DF}' +
    'html.dark .hdr{background:rgba(38,35,31,.82)}' +
    'html.dark .benefit{background:#2F2C27}' +
    'html.dark .launch-chip{background:rgba(156,203,171,.12)}' +
    'html.dark .benefit .ic,html.dark .points .ck{background:rgba(156,203,171,.14)}' +
    'html.dark .founder p.body{color:#CFC8BC}' +
    'html.dark dialog.legal .x{background:#2F2C27;color:#EEE9DF}' +
    'html.dark .asel .note,html.dark .asel .asel-note{background:#2F2C27;border-color:#3F3A33}' +
    'html.dark .asel .legal .in{background:#2B2824;color:#EEE9DF}' +
    'html.dark .asel input,html.dark .asel .row input{background:#2F2C27;color:#EEE9DF;border-color:#4A443C}' +
    'html.dark .asel .halo{opacity:1;background:radial-gradient(circle,rgba(156,203,171,.30) 0%,rgba(156,203,171,.10) 45%,rgba(156,203,171,0) 70%);filter:blur(28px)}' +
    'html.dark .asel .ring{border-color:rgba(238,233,223,.16)}html.dark .asel .ring::after{background:#9CCBAB;opacity:.95;box-shadow:0 0 12px rgba(156,203,171,.8)}' +
    'html.dark .asel .bottle{filter:drop-shadow(0 0 26px rgba(156,203,171,.22)) drop-shadow(0 34px 30px rgba(0,0,0,.55))}' +
    'html.dark .asel .shadow{background:rgba(0,0,0,.55)}' +
    'html.dark .asel .pill:not(.pill--solid){border-color:#4A443C;color:#EEE9DF}' +
    'html.dark .asel .pill--solid{background:#9CCBAB;color:#1A1816}' +
    'html.dark .asel .points li,html.dark .asel .benefit{border-color:#3F3A33}' +
    'html.ready-t,html.ready-t body{transition:background-color .5s ease,color .5s ease}html.vt,html.vt body{transition:none}' +
    '::view-transition-old(root),::view-transition-new(root){animation:none;mix-blend-mode:normal}' +
    '::view-transition-old(root){z-index:1}::view-transition-new(root){z-index:2;clip-path:circle(0 at var(--vt-x,50%) var(--vt-y,0%));animation:asel-wipe .42s cubic-bezier(.3,0,.1,1) forwards}' +
    '@keyframes asel-wipe{to{clip-path:circle(160vmax at var(--vt-x,50%) var(--vt-y,0%))}}' +
    '@media (prefers-reduced-motion:reduce){::view-transition-new(root){animation:none;clip-path:none}}' +
    '.asel-ctl{display:flex;align-items:center;gap:8px;margin-left:auto;margin-right:12px}' +
    '.asel-ctl button{appearance:none;border:1px solid var(--line);background:transparent;color:var(--ink);border-radius:999px;' +
    'height:36px;min-width:36px;padding:0 12px;font:500 13px/1 Inter,system-ui,sans-serif;cursor:pointer;display:inline-flex;align-items:center;gap:6px;' +
    'transition:background .25s,border-color .25s,transform .25s}' +
    '.asel-ctl button:hover{background:var(--sage);transform:translateY(-1px)}' +
    '.asel-ctl .lang{position:relative}.asel-ctl .lang .cur{font-weight:600;letter-spacing:.04em}' +
    '.asel-ctl .menu{position:absolute;top:calc(100% + 8px);right:0;min-width:140px;padding:6px;border-radius:16px;background:var(--bg);border:1px solid var(--line);box-shadow:0 18px 40px rgba(0,0,0,.14);display:none;flex-direction:column;gap:2px;z-index:60}' +
    '.asel-ctl .lang.open .menu{display:flex}' +
    '.asel-ctl .menu button{border:0;border-radius:10px;justify-content:flex-start;height:34px;padding:0 12px;width:100%}' +
    '.asel-ctl .menu button.on{background:var(--sage);font-weight:600}' +
    '.asel-ctl svg{width:16px;height:16px;display:block}' +
    '.asel-ctl .theme:hover svg{animation:asel-lantern .9s steps(1,end) 1}' +
    '@keyframes asel-lantern{0%{opacity:1}12%{opacity:.15}22%{opacity:1}34%{opacity:.25}46%{opacity:1}62%{opacity:.5}74%{opacity:1}}' +
    '.hdr .wrap{display:flex;align-items:center}' +
    '@media (max-width:640px){.asel-ctl{margin-right:8px;gap:6px}.asel-ctl button{height:32px;min-width:32px;padding:0 9px;font-size:12px}}' +
    '.stage{touch-action:pan-y;cursor:grab;user-select:none;-webkit-user-select:none}' +
    '.stage.grab{cursor:grabbing}' +
    '.stage.grab .bottle,.stage.inertia .bottle{animation:none}' +
    '.stage .bottle{will-change:transform;transform-style:preserve-3d;backface-visibility:hidden}' +
    '.stage .hint{position:absolute;bottom:4%;left:50%;transform:translateX(-50%);font:500 12px/1 Inter,system-ui,sans-serif;color:var(--muted);' +
    'letter-spacing:.08em;text-transform:uppercase;opacity:0;animation:asel-hint 1s ease 2.2s forwards;pointer-events:none;white-space:nowrap}' +
    '@keyframes asel-hint{to{opacity:.8}}' +
    '.stage.touched .hint{animation:none;opacity:0;transition:opacity .4s}' +
    '@media (prefers-reduced-motion:reduce){.stage .hint{animation:none;opacity:.8}}';
  var I = window.ASEL_I18N || { LANGS: ['de'], K: {}, TR: {} }, LANGS = I.LANGS, K = I.K, TR = I.TR;
  var T = {};
  Object.keys(K).forEach(function (id) { var de = K[id]; T[de] = {}; LANGS.forEach(function (l) { if (l !== 'de') T[de][l] = TR[l][id]; }); });
  var PH = { 'du@gute-mail.de': { en: 'you@good-mail.com', es: 'tu@correo.com', cs: 'ty@mail.cz' } };
  var ALT = { 'Nino, Gründer von ASELECION': { en: 'Nino, founder of ASELECION', es: 'Nino, fundador de ASELECION', cs: 'Nino, zakladatel ASELECION' },
              'Nino, Gründer von ASELECION, mit Hydrate My Curls': { en: 'Nino, founder of ASELECION, with Hydrate My Curls', es: 'Nino, fundador de ASELECION, con Hydrate My Curls', cs: 'Nino, zakladatel ASELECION, s Hydrate My Curls' } };
  function tr(de, lang) { return lang === 'de' ? de : (T[de] && T[de][lang]) || de; }
  var ORIG = new WeakMap();
  function collectNodes() {
    var list = [];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || /^(SCRIPT|STYLE)$/.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = walker.nextNode())) {
      var raw = ORIG.has(n) ? ORIG.get(n) : n.nodeValue, key = raw.trim();
      if (T[raw] !== undefined || T[key] !== undefined) { ORIG.set(n, raw); list.push({ node: n, raw: raw, key: T[raw] !== undefined ? raw : key }); }
    }
    return list;
  }
  function applyLang(lang) {
    if (LANGS.indexOf(lang) < 0) lang = 'en';
    collectNodes().forEach(function (e) { e.node.nodeValue = e.raw.replace(e.key, tr(e.key, lang)); });
    document.querySelectorAll('input[placeholder]').forEach(function (i) {
      var de = i.getAttribute('data-ph-de') || i.placeholder;
      i.setAttribute('data-ph-de', de);
      i.placeholder = (lang !== 'de' && PH[de] && PH[de][lang]) || de;
    });
    document.querySelectorAll('img[alt]').forEach(function (i) {
      var de = i.getAttribute('data-alt-de') || i.alt;
      i.setAttribute('data-alt-de', de);
      i.alt = (lang !== 'de' && ALT[de] && ALT[de][lang]) || de;
    });
    document.documentElement.lang = lang;
    var l = document.querySelector('.asel-ctl .lang');
    if (l) { l.querySelector('.cur').textContent = lang.toUpperCase(); l.querySelectorAll('.menu button').forEach(function (b) { b.classList.toggle('on', b.dataset.l === lang); }); }
    try { localStorage.setItem(LS_LANG, lang); } catch (e) {}
  }
  var TH = window.ASEL_THEME || { auto: function () { return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'; }, manual: function () { return null; }, current: function () { return this.auto(); }, set: function () {} };
  function applyTheme(t) {
    document.documentElement.classList.toggle('dark', t === 'dark');
    var m = document.querySelector('meta[name=theme-color]');
    if (m) m.setAttribute('content', t === 'dark' ? '#26231F' : '#F2EFE6');
    var b = document.querySelector('.asel-ctl .theme');
    if (b) b.innerHTML = t === 'dark' ? SUN : MOON;
  }
  var SUN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';
  var MOON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>';
  function buildControls() {
    var wrap = document.querySelector('.hdr .wrap');
    if (!wrap || document.querySelector('.asel-ctl')) return;
    var ctl = document.createElement('div');
    ctl.className = 'asel-ctl';
    ctl.innerHTML =
      '<div class="lang"><button type="button" class="cur" aria-haspopup="listbox" aria-label="Sprache / Language">DE</button>' +
      '<div class="menu" role="listbox"><button type="button" data-l="de">Deutsch</button><button type="button" data-l="en">English</button><button type="button" data-l="es">Español</button><button type="button" data-l="cs">Čeština</button></div></div>' +
      '<button type="button" class="theme" aria-label="Hell / Dunkel"></button>';
    var pill = wrap.querySelector('.pill');
    wrap.insertBefore(ctl, pill || null);
    var lang = ctl.querySelector('.lang');
    lang.querySelector('.cur').addEventListener('click', function (e) { e.stopPropagation(); lang.classList.toggle('open'); });
    lang.querySelectorAll('.menu button').forEach(function (b) {
      b.addEventListener('click', function () { applyLang(b.dataset.l); lang.classList.remove('open'); });
    });
    document.addEventListener('click', function () { lang.classList.remove('open'); });
    ctl.querySelector('.theme').addEventListener('click', function (ev) {
      var next = document.documentElement.classList.contains('dark') ? 'light' : 'dark';
      var r = ev.currentTarget.getBoundingClientRect();
      document.documentElement.style.setProperty('--vt-x', (r.left + r.width / 2) + 'px');
      document.documentElement.style.setProperty('--vt-y', (r.top + r.height / 2) + 'px');
      TH.set(next);
      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
        document.documentElement.classList.add('vt');
        document.startViewTransition(function () { applyTheme(next); }).finished.then(function () { document.documentElement.classList.remove('vt'); });
      } else applyTheme(next);
    });
  }
  function bottle() {
    var stage = document.querySelector('.stage'), img = stage && stage.querySelector('.bottle');
    if (!stage || !img) return;
    var hint = document.createElement('span');
    hint.className = 'hint';
    hint.textContent = 'ziehen zum drehen';
    stage.appendChild(hint);
    var ry = -13, rz = 1.5, vy = 0, dragging = false, lastX = 0, raf = 0;
    function render() {
      img.style.transform = 'translateY(' + (dragging ? -6 : 0) + 'px) rotateY(' + ry + 'deg) rotateZ(' + rz + 'deg)';
    }
    function loop() {
      if (dragging) { render(); raf = requestAnimationFrame(loop); return; }
      ry += vy; vy *= 0.94;
      var back = (-13 - ry) * 0.035; ry += back;
      render();
      if (Math.abs(vy) > 0.05 || Math.abs(back) > 0.05) raf = requestAnimationFrame(loop);
      else { stage.classList.remove('inertia'); img.style.transform = ''; raf = 0; ry = -13; }
    }
    function down(e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true; stage.classList.add('grab', 'touched'); stage.classList.remove('inertia');
      lastX = e.clientX; vy = 0;
      if (img.style.transform === '') ry = -13;
      stage.setPointerCapture && stage.setPointerCapture(e.pointerId);
      if (!raf) raf = requestAnimationFrame(loop);
      e.preventDefault();
    }
    function move(e) {
      if (!dragging) return;
      var dx = e.clientX - lastX; lastX = e.clientX;
      vy = dx * 0.6; ry += vy;
      rz = 1.5 + Math.max(-4, Math.min(4, dx * 0.15));
    }
    function up() {
      if (!dragging) return;
      dragging = false; stage.classList.remove('grab'); stage.classList.add('inertia'); rz = 1.5;
      if (!raf) raf = requestAnimationFrame(loop);
    }
    stage.addEventListener('pointerdown', down);
    window.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
    if (window.matchMedia('(hover:hover) and (prefers-reduced-motion:no-preference)').matches) {
      stage.addEventListener('mousemove', function (e) {
        if (dragging || raf) return;
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        img.style.transform = 'translateY(0) rotateY(' + (-13 + x * 22) + 'deg) rotateZ(' + (1.5 - y * 3) + 'deg)';
        img.style.animation = 'none';
      });
      stage.addEventListener('mouseleave', function () {
        if (dragging || raf) return;
        img.style.transform = ''; img.style.animation = '';
      });
    }
  }
  function init() {
    var style = document.createElement('style'); style.textContent = CSS; document.head.appendChild(style);
    buildControls();
    var lang = null;
    try { lang = localStorage.getItem(LS_LANG); } catch (e) {}
    if (!lang) { var nl = (navigator.language || 'en').slice(0, 2).toLowerCase(); lang = LANGS.indexOf(nl) >= 0 ? nl : 'en'; }
    applyTheme(TH.current());
    requestAnimationFrame(function () { requestAnimationFrame(function () { document.documentElement.classList.add('ready-t'); }); });
    function reAuto() { if (!TH.manual()) applyTheme(TH.auto()); }
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    (mq.addEventListener ? mq.addEventListener('change', reAuto) : mq.addListener(reAuto));
    setInterval(reAuto, 300000);
    window.addEventListener('pageshow', function () { applyTheme(TH.current()); });
    bottle();
    applyLang(lang);
    var mo = new MutationObserver(function () { var cl = document.documentElement.lang; if (cl !== 'de') { mo.disconnect(); applyLang(cl); mo.observe(document.body, { childList: true, subtree: true }); } });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
